'use client';

import { Suspense, useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { isMetaAdsSession, persistMetaAdsSessionIfPresent } from '@/lib/analytics/meta-ads-session';

const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID?.trim() || undefined;

function MetaPixelInner() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const search = searchParams.toString();
  const tagsInitialized = useRef(false);

  useEffect(() => {
    persistMetaAdsSessionIfPresent(search);
  }, [search]);

  useEffect(() => {
    if (!META_PIXEL_ID) return;
    persistMetaAdsSessionIfPresent(search);
    if (!isMetaAdsSession()) return;

    let cancelled = false;
    void import('react-facebook-pixel').then(({ default: ReactPixel }) => {
      if (cancelled) return;
      if (!tagsInitialized.current) {
        ReactPixel.init(META_PIXEL_ID, undefined, {
          autoConfig: true,
          debug: process.env.NODE_ENV === 'development',
        });
        ReactPixel.grantConsent();
        tagsInitialized.current = true;
      }
      ReactPixel.pageView();
    });
    return () => {
      cancelled = true;
    };
  }, [pathname, search]);

  return null;
}

export function MarketingAnalytics() {
  return (
    <Suspense fallback={null}>
      <MetaPixelInner />
    </Suspense>
  );
}
